const nexcess = {
  logo: require("@/assets/Nx-1c-WHITE-Logo-Horizontal.svg"),
  login_top: require("@/assets/Nx-1c-BLUE-Single_Logo.svg"),
  cdn_info_link: "https://www.nexcess.net/help/what-is-a-content-delivery-network-cdn/",
};

export default nexcess;
